"use client"
import React from "react";

const ProfileTypeIcon = ({ type }) => {
  if (type === "BUSINESS") {
    return <i className="fa-solid fa-shop"></i>;
  } else if (type === "POI") {
    return <i className="fa-solid fa-map-location"></i>;
  } else if (type === "COMMUNITY") {
    return <i className="fa-solid fa-people-group"></i>;
  } else if (type === "AMBASSADOR") {
    return <i className="fa-solid fa-palette"></i>;
  } else if (type === "POINT" || type === "POST") {
    return <i className="fa-solid fa-map-pin"></i>;
  } else if (type === "STORY" || type === "MAP") {
    return <i className="fa-solid fa-map"></i>;
  } else if (type === "EVENT") {
    return <i className="fa-solid fa-calendar-star"></i>;
  } else {
    return <></>;
  }
};
export default ProfileTypeIcon;
